<template>
  <div class="container">
    <header>
      <img :src="icon" alt="" />
      <div class="nameBox">
        <p>{{ nick_name }}</p>
        <p>班级门数: {{ classNum }}</p>
      </div>
      <div class="btnBox">
        <div class="editBox" :style="{ width: isEnableNotice ? '3.3rem' : '3rem' }" @click="editMessage">编辑资料</div>
        <div :class="['weChatBox', isEnableNotice && 'enable-notice']" @click="showQrCodeDialog"><van-icon name="chat-o" />{{ isEnableNotice ? '已开通服务号通知' : '接收服务号通知' }}</div>
      </div>
    </header>

    <main>
      <p class="myFunction">我的功能</p>
      <div class="functionBox">
        <div
          class="functionItem"
          v-show="!item.hide"
          v-for="(item, index) of functionList"
          :key="index"
          @click="toPath(item)"
          :style="{ background: item.backgroundColor }"
        >
          <img :src="item.imgUrl" alt="" />
          <div v-if="item.toPath=='homework'&&unreadCount!=0" class="dot">{{unreadCount}}</div>
          <p>{{ item.title }}</p>
        </div>
      </div>
    </main>

    <van-popup
      class="phoneVanpopup"
      v-model="show"
    >
    <div>
      <p class="kefu">客服电话</p>
      <p class="kefudianhua">
        {{ web_contact_number }}
      </p>
      <div class="call">
        <span @click="gitList()" class="quxiao">取消</span>
        <span @click="callPhone" class="lijiboda">立即拨打</span>
      </div>
      </div>
      <!-- <div class="empty" v-else>
      <img class="emptyImg" src="../../assets/images/empty_phone.png" alt="">
      <span class="emptyPhoneText">暂未配置客服电话</span>
      </div> -->
    </van-popup>


    <van-popup
      class="noticePopup"
      v-model="qrCodeDialogShow"
    >
      <div class="noticePopupContent">
        <div class="noticeQrArea">
          <div ref="noticeQrCode" class="noticeQrCode" v-if="qrCodeDialogShow">
            <div id="qrCodeDom" style="width: 200px; height: 200px; margin: auto"></div>
          </div>
        </div>
        <div class="noticeDivider"></div>
        <div class="noticeTips">
          <p>1：长按保存二维码至微信内识别关注公众号</p>
          <p>2：需通过本二维码关注公众号，直接关注公众号无法接受上课通知！</p>
        </div>
      </div>
      <div class="dialogCloseBtn" @click="closeQrCodeDialog" />
    </van-popup>
    <!-- 尾部 -->
    <div style="margin-top: 48px">
      <van-tabbar active-color="#1872ed" v-model="active" :safe-area-inset-bottom="false">
        <van-tabbar-item name="home" icon="home-o" :to="{ path: '/' }" v-if="hideTab != 'home'" >
          <span>首页</span>
          <template #icon="props">
            <img :src="props.active ? home.active : home.inactive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item name="study" :to="{ path: 'myStudy', query: { setid: 123123 ,hideTab:hideTab} }">
          <span>学习</span>
          <template #icon="props">
            <img :src="props.active ? study.active : study.inactive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item
          name="my"
          :to="{ path: 'my', query: { setid: 123123 ,hideTab:hideTab} }"
          v-if="unreadCount!=0" :badge="unreadCount"
        >
          <span>我的</span>
          <template #icon="props">
            <img :src="props.active ? my.active : my.inactive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item
         name="my"
          :to="{ path: 'my', query: { setid: 123123 ,hideTab:hideTab} }"
          v-else
        >
          <span>我的</span>
          <template #icon="props">
            <img :src="props.active ? my.active : my.inactive" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Popup } from "vant";
import { mapGetters } from "vuex";
import QRCode from 'qrcodejs2'
import commApiRequest from "@/api/commApiRequest";

Vue.use(Popup);
export default {
  data() {
    return {
      hideTab: '',
      show: false,
      active:"my",
      nick_name: "",
      icon: "",
      classNum: "",
      web_contact_number: "",
      isEnableNotice: false,
      qrCodeDialogShow: false,
      qrCode: null,
      qrCodeImg: require("../../assets/img/An1.png"),
      my: {
        active: require("../../assets/images/my-active.png"),
        inactive: require("../../assets/images/my.png"),
      },
      study: {
        active: require("../../assets/images/study-active.png"),
        inactive: require("../../assets/images/study.png"),
      },
      home: {
        active: require("../../assets/images/home-active.png"),
        inactive: require("../../assets/images/home.png"),
      },
      functionList: [
         {
          title: "我的作业",
          imgUrl: require("../../assets/images/ico_homework@2x.png"),
          backgroundColor: "#fffaed",
          toPath: "homework",
        },
         {
          title: "历史观看",
          imgUrl: require("../../assets/images/aglook.png"),
          backgroundColor: "#fdf4f5",
          toPath: "HistoryViewing",
        },
          {
          title: "合同管理",
          imgUrl: require("../../assets/images/dianzihtt.png"),
          backgroundColor: "#f1f6ff",
          toPath: "contractmanagement",
          query: {
            setid: 123123,
          },
        },

        {
          title: "我的评测",
          imgUrl: require("../../assets/images/pingtest.png"),
          backgroundColor: "#f2f6fe",
          toPath: "pingtest",
          query: {
            setid: 123123,
          },
        },
        {
          title: "我的笔记",
          imgUrl: require("../../assets/images/my-note.png"),
          backgroundColor: "#fff6f1",
          toPath: "myNote",
        },
        {
          title: "观看数据",
          imgUrl: require("../../assets/images/view_data.png"),
          backgroundColor: "#fffaed",
          toPath: "viewDataCon",
          hide: true
        },
        {
          title: "客服热线",
          imgUrl: require("../../assets/images/kefuertu.png"),
          backgroundColor: "#f3fff6",
          toPath: "kefuertu",
        },
        {
          title: "关于我们",
          imgUrl: require("../../assets/images/guanyuertu.png"),
          backgroundColor: "#f6f4ff",
          toPath: "guanyu",
          query: {
            setid: 123123,
          },
        },
        {
          title: "绑定微信",
          imgUrl: require("../../assets/images/weixinbd.png"),
          backgroundColor: "rgb(255 244 254)",
          toPath: "BindWeChat",
        }
      ],
    };
  },
  computed: {
    ...mapGetters({
      unreadCount:'user/getUnreadCount'
    }),
  },
  created() {
        console.log("this.$route.query=====111=========");
    this.hideTab = this.$route.query.hideTab;
    this.getconfig();
    this.$ws.connectWithStoredUser();
    this.getUserInfo();
    this.web_contact_number = localStorage.getItem("web_contact_number");
    this.getCourseHomeworkRead()
  },
  mounted() {},
  methods: {
    showQrCodeDialog() {
      const data = {
        flag: 1,
        org_id: this.uid
      }
      commApiRequest('https://publicmessage.tenghuiwangxiao.cn').post('/getQrcode', data).then(res => {
        if(res.data.code === 200){
          this.qrCodeDialogShow = true
          this.$nextTick(() => {

            this.qrCode = new QRCode('qrCodeDom', {
              width: 200,
              height: 200,
              text: res.data.data.url
            })
          })
        }
      })
    },
    closeQrCodeDialog() {
      this.qrCodeDialogShow = false
      this.checkNoticeEnable()
      const timer = setInterval(() => {
        !this.isEnableNotice ? this.checkNoticeEnable() : clearInterval(timer)
      }, 5000)
    },
    async getCourseHomeworkRead(){
      const res=await this.$tenghuiApi.post('/onlineapi/user/index/getCourseRead')
        console.log('[<-- res作业未读数 -->] my',res);
        if (res.data.code==200) {
            this.$store.commit("user/setUnreadCount", res.data.data);
            localStorage.setItem('unreadCount',res.data.data)
      }
    },
    editMessage() {
      this.$router.push({ path: "ziliao", query: { setid: 123123 } });
    },
    toPath(item) {
      if (item.title === "客服热线") {
        this.show = true;
      } else {
        this.$router.push({ path: item.toPath, query: item.query });
      }
    },
    callPhone() {
      window.location.href = "tel://" + this.web_contact_number;
    },
    gitList() {
      this.show = false;
    },
    showPopup() {
      this.show = true;
    },
    async getconfig(){
      const res = await this.$api.post('/user/index/config')
      const { data } = res
      if (data.code === 200) {
        const courseReplayData = data.data.find(list => list.key ==='courseReplayData')
        if (courseReplayData) {
          this.functionList.forEach(element => {
            if (element.title === '观看数据') {
              element.hide = !(courseReplayData.value === 'true')
            }
          });
        }
      }
    },
    // handleClose (done) {
    // },
    checkNoticeEnable() {
      this.$api.post('/user/index/getUserInfo').then(res => {
        if (res.data.code === 200) {
          this.isEnableNotice = !!res.data.data.openid
        }
      })
    },
    getUserInfo() {
      // 获取用户信息
      const data = {};
      this.$api.post("/user/index/getUserInfo", data).then((res) => {
        if (res.data.code === 200) {
          this.$store.commit("user/setFansId", res.data.data.id);
          localStorage.setItem("tengface_fans_id", res.data.data.id);
          this.$ws.connect({ userId: res.data.data.id });
          this.nick_name = res.data.data.nick_name;
          this.icon = res.data.data.icon;
          this.classNum = res.data.data.classNum;
          this.isEnableNotice = !!res.data.data.openid
          localStorage.setItem("nick", res.data.data.nick_name);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 40px 20px 0;
  background-image: linear-gradient(160deg, #e0edff 10%, #fff 50%);

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70px;
    margin-bottom: 1.5rem;

    img {
      width: 1.81rem;
      height: 1.81rem;
      border-radius: 50%;
      margin-right: 20px;
    }

    .nameBox {
      flex: 1;
      color: #101010;

      & p:first-child {
        font-size: 20px;
        color: #202020;
        font-weight: 400;
        margin-bottom: 0px;
      }

      & p:last-child {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-top: 9px;
      }
    }
    .btnBox {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
    .editBox,
    .weChatBox {
      width: 1.92rem;
      height: 0.75rem;
      line-height: 0.75rem;
      border-radius: 16px;
      text-align: center;
      color: #fff;
      background: linear-gradient(133deg, #73aaff 3%, #0053ff 91%);
    }
    .weChatBox {
      width: 3rem;
      background: linear-gradient(133deg, #07c160 3%, #00a854 91%);
      margin-top: 0.1rem;
      &.enable-notice {
        width: 3.3rem;
        background: linear-gradient(133deg, #e8e8e8 3%, #c8c8c8 91%);
        color: #0b0b0b;
      }
      i {
        margin-right: 0.1rem;
      }
    }
  }

  main {
    .myFunction {
      font-size: 16px;
      font-weight: 400;
    }
    .functionBox {
      // display: flex;
      // flex-wrap: wrap;
      // justify-content: space-between;
      // align-items: center;
      margin-top: 20px;
      .functionItem {
        margin-left: 11px;
        float: left;
        box-sizing: border-box;
        width: 100px;
        height: 100px;
        border-radius: 10px;
        text-align: center;
        padding: 15px 0;
        margin-bottom: 20px;
        box-shadow: 0px 4px 10px 0px rgba(26,88,172,0.06);
        position: relative;
        .dot{
          position: absolute;
          box-sizing: border-box;
          border-radius: 16px;
          padding: 0 3px;
          min-width: 16px;
          color: #fff;
          font-size: 12px;
          font-weight: 500;
          line-height: 1.2;
          text-align: center;
          background-color: #ee0a24;
          border: 1px solid #fff;
          top: 10px;
          left: 55px;
        }
        img {
          width: 30px;
          height: 30px;
        }
        &:nth-child(3),
        &:nth-child(6){
          margin-right: 0;
        }
      }
    }
  }
}
.phoneVanpopup{
   width: 280px;
   height: 170px;
   background: #ffffff;
   border-radius: 10px;
   text-align: center;
}
.noticePopup {
  width: 70vw;
  border-radius: 12px;
  background: transparent;
}
.noticePopupContent {
  position: relative;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
}
.noticeQrArea {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 26px 0 22px;
}
.noticeQrCode {
  &, img {
    width: 200px;
    height: 200px;
  }
}
.noticeDivider {
  position: relative;
  border-top: 1px dashed #e8e8e8;
  &::before,
  &::after {
    content: "";
    position: absolute;
    top: -11px;
    width: 22px;
    height: 22px;
    background: #4C4C4C;
    border-radius: 50%;
  }
  &::before {
    left: -11px;
  }
  &::after {
    right: -11px;
  }
}
.noticeTips {
  padding: 0.7rem;
  font-size: 14px;
  line-height: 1.5;
  color: #7F7F7F;
  p:nth-child(1) {
    margin-bottom: 0.2rem;
  }
}
.dialogCloseBtn {
  width: 48px;
  height: 48px;
  margin: 0 auto;
  cursor: pointer;
  background: url(@/assets/images/dialog_close_btn.png) no-repeat center center;
  background-size: 100% 100%;
}
.kefudianhua {
  font-size: 28px;
  font-family: DINPro, DINPro-Bold;
  font-weight: 400;
  text-align: left;
  color: #101010;
  text-align: center;
  margin-top: 8px;
  margin-bottom:20px
}
.call{
  display: flex;
  justify-content: space-between;
  padding: 0 25px;
}
.kefu {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #101010;
  text-align: center;
  margin-top: 14px;
}
.empty{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-items: center;
  .emptyImg{
  left: 50%;
  width: 121px;
  height: 121px;
}
.emptyPhoneText{
  color: #666666;
  font-size: 14px;
  font-weight: 400;
}
}
.lijiboda {
  background: linear-gradient(132deg, #73aaff 2%, #0053ff 93%);
  border-radius: 17px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #ffffff;
  padding: 8px 26px;
}
.quxiao {
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #101010;
  background: #efefef;
  border-radius: 17px;
  padding: 8px 37px;
}
</style>
